module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1233Uel/tc-custom/9781614233220.jpg?1702083505735",
      "alt": "This image is the cover for the book Hauntings of the Hudson River Valley"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hauntings of the Hudson River Valley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The true stories behind three terrifying local legends—photos included.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This book delves into three enigmatic folk legends of New York’s Hudson River Valley: the stories of Sybil Ludington, Chief Daniel Nimham, and George Denny. Each was the central figure in a dramatic series of events; each became enshrined in local lore for their actions; each has had their true story obscured; and each may have left behind a spiritual residue."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Follow Vincent Dacquino as he interviews local experts, explores areas where hauntings may have occurred—such as Carmel’s legendary Smalley’s Inn—and digs deep into historical archives to open new windows into the lives, and possible afterlives, of these three mysterious characters.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Vincent T. Dacquino\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Vin Dacquino, who holds both a bachelor's and master's degree in education, is the author of seven books, having focused in the past on juvenile biographies. Formerly the director of teacher training for the Tuckahoe, Eastchester, and Pelham schools, Dacquino was the 1983 recipient of the Jenkins PTA Memorial Award, and has also been named an honorary member of the New York State Congress of Parents and Teachers. Profiled in the 2001-2004 editions of Who's Who in America, as well as the 2005 Who's Who in American Education, Dacquino lives in Mahopac with his wife, with whom he has two children.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0